import { render, staticRenderFns } from "./WhatsappPreview.vue?vue&type=template&id=2083447e&scoped=true"
import script from "./WhatsappPreview.vue?vue&type=script&lang=js"
export * from "./WhatsappPreview.vue?vue&type=script&lang=js"
import style0 from "./WhatsappPreview.vue?vue&type=style&index=0&id=2083447e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083447e",
  null
  
)

export default component.exports